var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYearsMarket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clone page",
    clipPath: "url(#clip0_59_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    transform: "translate(-120 -1152)",
    fill: "#FFFBFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inquiry author info"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -275.5,
    width: 399,
    height: 474,
    rx: 19.5,
    stroke: "black",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip1_59_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6351 17.6218C13.4389 17.4256 13.1917 17.1783 13.0381 17C13.1917 16.8217 13.439 16.5744 13.6351 16.3782C14.6484 15.365 16.2673 13.7457 16.6186 11.375H18.5625V9.5H5.4375V11.375H7.38136C7.73269 13.7457 9.35161 15.365 10.3649 16.3782C10.5611 16.5744 10.8083 16.8217 10.9619 17C10.8083 17.1783 10.5611 17.4256 10.3649 17.6218C9.35161 18.635 7.73269 20.2542 7.38136 22.625H5.4375V24.5H18.5625V22.625H16.6186C16.2673 20.2543 14.6484 18.635 13.6351 17.6218ZM9.28556 11.375H14.7144C14.3721 12.9895 13.2015 14.1602 12.3093 15.0523C12.2014 15.1603 12.098 15.2638 12 15.364C11.902 15.2637 11.7987 15.1603 11.6907 15.0523C10.7985 14.1602 9.62794 12.9895 9.28556 11.375ZM11.6907 18.9477C11.7986 18.8397 11.902 18.7362 12 18.636C12.098 18.7363 12.2013 18.8397 12.3093 18.9477C13.2015 19.8398 14.3721 21.0105 14.7144 22.625H9.28556C9.62794 21.0105 10.7985 19.8398 11.6907 18.9477Z",
    fill: "#4D2481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4375 2.375V0.5H18.5625V2.375H12.9375V0.5H11.0625V2.375H5.4375V0.5H3.5625V2.375H2.8125C1.2592 2.375 0 3.6342 0 5.1875V17.9375C0 19.4908 1.2592 20.75 2.8125 20.75H5.92786C6.17784 20.0557 6.50433 19.4317 6.86222 18.875H2.8125C2.29472 18.875 1.875 18.4553 1.875 17.9375V8H22.125V17.9375C22.125 18.4553 21.7053 18.875 21.1875 18.875H17.1378C17.4957 19.4317 17.8222 20.0557 18.0721 20.75H21.1875C22.7408 20.75 24 19.4908 24 17.9375V5.1875C24 3.6342 22.7408 2.375 21.1875 2.375H20.4375ZM1.875 6.125V5.1875C1.875 4.66972 2.29472 4.25 2.8125 4.25H21.1875C21.7053 4.25 22.125 4.66972 22.125 5.1875V6.125H1.875Z",
    fill: "#4D2481"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2944,
    fill: "white",
    transform: "translate(-120 -1152)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_59_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearsMarket);
export default __webpack_public_path__ + "static/media/years-market.969f06eb5c65598a12f150ec6c773e8d.svg";
export { ForwardRef as ReactComponent };